import React from 'react'
import { PeopleFill } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'
import EnrolleeName from '../../user/last-first-name'

const Droppers = ({
    users = []
}) => {
    const { breakpoint, breakpoints } = useViewport()
    const renderEnrollee = (user) => {
        return (
            <div key={user.id} className='ellipsis-truncate'><EnrolleeName user={user} /></div>
        )
    }
    return (
        <div style={{ paddingTop: '10px'}}>
            <div>
                <PeopleFill size={30} />
                <span  style={{ paddingLeft: '10px'}}>
                    {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Students Dropped' : ''} ({users.length})</span>
            </div>
            <div style={{ paddingLeft: '20px', paddingTop: '15px', color: 'rgb( 137, 138, 139)'}}>
                {users.map(renderEnrollee)}
            </div>
        </div>
    )
}

export default Droppers